import React from "react";
import {SocialIcon} from "react-social-icons";
import Particles from 'react-particles-js';

import Avatar from "./Avatar";
import "./Home.scss";

export const Home = () => {

    const params = {
        particles: {
            number: {
                value: 100
            },
            size: {
                value: 3
            }
        },
        interactivity: {
            events: {
                onhover: {
                    enable: true,
                    mode: "repulse"
                }
            }
        }
    };

return (
            <div className="home-container align-items-center text-center w-100 m-auto">
                <Particles params={params} className="particles"/>
                <div className="row p-0 w-100 justify-content-md-center">
                    <div className="col-md-5 col-sm-12 d-flex align-items-center justify-content-center">
                        <div className="user-item__image text-center ">
                            <Avatar className="p-5" image="https://miro.medium.com/max/3150/2*W4u-LlYiX0CvfYZWI35O0g.jpeg"
                                    alt="Sahan Amarsha"/>
                        </div>
                    </div>
                    <div className="col-md-7 col-sm-12 d-flex align-items-center p-0 justify-content-center">
                        <div className="row align-self-center banner-text d-flex flex-column justify-content-center">
                            <h1 className="col text-white">SAHAN AMARSHA</h1>
                            <h3 className="col text-light">Developer | Undergraduate</h3>
                            <div className="col d-flex mt-3 mb-4 align-items-center justify-content-center">
                                <div className="row d-flex justify-content-center">
                                    <SocialIcon
                                        className="socialIcon rounded-circle"
                                        fgColor={"#ffffff"}
                                        network={"facebook"}
                                        style={{height: 80, width: 80}}
                                        url={"https://www.facebook.com/sahanamarsha"}
                                        target={"_blank"}
                                    />
                                    <SocialIcon
                                        className="socialIcon rounded-circle"
                                        fgColor={"#ffffff"}
                                        network={"youtube"}
                                        style={{height: 80, width: 80}}
                                        url={"https://www.youtube.com/channel/UC0JuCFoygq1TdwIYi7oUXMw"}
                                        target={"_blank"}
                                    />
                                    <SocialIcon
                                        className="socialIcon rounded-circle"
                                        fgColor={"#ffffff"}
                                        network={"linkedin"}
                                        style={{height: 80, width: 80}}
                                        url={"https://www.linkedin.com/in/sahanamarsha/"}
                                        target={"_blank"}
                                    />
                                    <SocialIcon
                                        className="socialIcon rounded-circle"
                                        fgColor={"#ffffff"}
                                        network={"medium"}
                                        style={{height: 80, width: 80}}
                                        url={"https://sahanamarsha.medium.com/"}
                                        target={"_blank"}
                                    />
                                    <SocialIcon
                                        className="socialIcon rounded-circle"
                                        fgColor={"#ffffff"}
                                        network={"github"}
                                        style={{height: 80, width: 80}}
                                        url={"https://github.com/SahanAmarsha"}
                                        target={"_blank"}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )

}


export default Home;
